import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { ReleaseComponent } from '../../../../types/releaseComponent';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from '../../../../constants/registrationStep';

/**
 * リリースコンポーネント更新画面の状態
 */
interface EditState {
  /** ロード状態 */
  loading: boolean;
  /** 表示中のコンポーネント */
  selected: ReleaseComponent | null;
  /** 削除確認モーダルの表示状態 */
  isOpenModalDelete: boolean;
  /** 基本情報の更新確認モーダルの表示状態 */
  isOpenModalEdit: boolean;
  /** バージョン追加ステップ */
  step: RegistrationStep;
}

/**
 * リリースコンポーネント更新画面の初期状態
 */
const initialState: EditState = {
  step: REGISTRATION_STEP.INPUT,
  loading: false,
  selected: null,
  isOpenModalDelete: false,
  isOpenModalEdit: false,
};

/**
 * リリースコンポーネント更新画面の slice(reducer + action)
 */
export const editSlice = createSlice({
  name: 'editReleaseComponent',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (
      state,
      { payload }: PayloadAction<EditState['selected']>,
    ) => ({
      ...state,
      selected: payload,
    }),
    updateLoadingStatus: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      loading: payload,
    }),
    updateIsOpenModalDelete: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      isOpenModalDelete: payload,
    }),
    updateIsOpenModalEditDetail: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => ({
      ...state,
      isOpenModalEditDetail: payload,
    }),
  },
});

/**
 * リリースコンポーネント更新画面の action
 */
export const editActions = editSlice.actions;

/**
 * リリースコンポーネント更新画面の selectors
 */
export const editSelectors = {
  selectedReleaseComponent: (state: RootState) =>
    state.releaseComponent.edit.selected,
  isOpenModalDelete: (state: RootState) =>
    state.releaseComponent.edit.isOpenModalDelete,
  isOpenModalEdit: (state: RootState) =>
    state.releaseComponent.edit.isOpenModalEdit,
  currentModalStep: (state: RootState) =>
    state.releaseComponent.registration.step,
} as const;
